
import { gql } from '@apollo/client';

export const GET_CITIES = gql`
  query GetCities {
    cities {
      id
      name
      nameEn
    }
  }
`;

export const GET_DISTRICTS = gql`
query Districts($cityId: ID) {
  districts(cityId: $cityId) {
    id
    name
    nameEn
  }
}
`;

export const GET_QUARTERS = gql`
  query GetQuarters($districtId: ID!) {
    quarters(districtId: $districtId) {
      id
      name
    }
  }
`;


